import React, { useState, useEffect } from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../../components/fields/TextInput/TextInputWithLabel';
import Switches from '../../../../../components/fields/Switches/Switches';
import { nameTransform } from '../../../../../utils/utils';
import FIODTO from '../../../../../dto/FIODTO';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../../configs';
import FileInput from '../../../../../components/fields/FileInput/FileInput';

export default function FIOForm(props) {
  const {
    prefix = 'applicant_new.',
    control,
    formMeta,
    applicantType,
    procedure,
    isEdit = false,
    currentApplication = {},
    setValue,
    getValues,
  } = props;

  const [showFIO, setShowFIO] = useState(
    isEdit ? !!(
      currentApplication?.applicant_new?.last_name
        || currentApplication?.applicant_new?.first_name
        || currentApplication?.applicant_new?.middle_name
    ) || currentApplication?.applicant_new?.last_name === null
      || currentApplication?.applicant_new?.first_name === null
      || currentApplication?.applicant_new?.middle_name === null : false,
  );

  const dto = new FIODTO({ optional: true });
  const attributes = dto.getAttributesByName();

  useEffect(() => {
    setValue('applicant_new.last_name', !showFIO ? null : (isEdit ? getValues('applicant_new.last_name') || '' : ''));
    setValue('applicant_new.first_name', !showFIO ? null : (isEdit ? getValues('applicant_new.first_name') || '' : ''));
    setValue('applicant_new.middle_name', !showFIO ? null : (isEdit ? getValues('applicant_new.middle_name') || '' : ''));
    if (!showFIO) setValue('media.fio_change_document', null);
  }, [showFIO]);

  const isValidProcedure = [PROCEDURE_TYPE.PROCEDURE_1227_5, PROCEDURE_TYPE.PROCEDURE_1227_8, PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure);
  const isValidApplicantType = [USER_TYPE.PRIVATE_PERSON_OLD, USER_TYPE.PRIVATE_PERSON, USER_TYPE.INDIVIDUAL_ENTREPRENEUR].includes(applicantType);

  if (!isValidProcedure || !isValidApplicantType) {
    return null;
  }

  return (
    <>
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setShowFIO(!showFIO),
              value: showFIO,
            }}
            label="Изменилось ФИО"
          />
        </Col>
      </Row>
      {showFIO && (
        <>
          <Row className="row-cols-3">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.last_name}
              variant="material"
              namePrefix={prefix}
              transform={nameTransform}
              labelPrefix="new."
            />
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.first_name}
              variant="material"
              namePrefix={prefix}
              transform={nameTransform}
              labelPrefix="new."
            />
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.middle_name}
              variant="material"
              namePrefix={prefix}
              transform={nameTransform}
              labelPrefix="new."
            />
          </Row>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={FileInput}
              dtoObject={attributes.fio_change_document}
              variant="material"
              namePrefix="media."
            />
          </Row>
        </>
      )}
      <div className="hr-row mt-3" />
    </>
  );
}
